import React, { useContext } from "react";
import { DataVendorCostAllocationRequestCustomerDetails } from "interfaces/Mueller.Business.Models";
import MGrid, { ACTION_ADD, MGridColumnDefinition } from "../MGrid";
import { DATA_TYPE_STRING, DATA_TYPE_BUTTON } from "typeConstants/dataTypes";
import { DialogContext, DialogProviderValue } from "components/Shared/DialogProvider";
import TechCostCustomerSurveyTypeChooser from "./TechCostCustomerSurveyTypeChooser";

interface TechCostCustomerSurveyTypesProps {
  entries: DataVendorCostAllocationRequestCustomerDetails[];
  onAdd: (entry: DataVendorCostAllocationRequestCustomerDetails) => void;
  onDelete: (index: number) => void;
}

const TechCostCustomerSurveyTypes = (props: TechCostCustomerSurveyTypesProps) => {
  const dialog = useContext<DialogProviderValue>(DialogContext);

  const onCellButtonClick = (selectedOriginalIndex: number) => props.onDelete(selectedOriginalIndex);

  const wrappedOnAdd = (entry: DataVendorCostAllocationRequestCustomerDetails) => {
    props.onAdd(entry);
    dialog.hide();
  };
  const showAddDialog = () => {
    const dialogProps = { className: "dialog-500px-width-height" };
    dialog.show(
      "Add Entry",
      <TechCostCustomerSurveyTypeChooser onSave={wrappedOnAdd} onCancel={dialog.hide} />,
      null,
      dialogProps
    );
  };

  const deleteButton = () => <i className="md-icon material-icons">delete</i>;
  let columns: MGridColumnDefinition[] = [
    {
      key: "majorCompanyCode",
      name: "Major Company",
      width: 250,
      dataSource: "majorCompanyCode",
      dataType: DATA_TYPE_STRING,
    },
    { key: "customerNumber", name: "Customer #", width: 100, dataSource: "customerNumber", dataType: DATA_TYPE_STRING },
    {
      key: "surveyTypeCode",
      name: "Survey Type",
      width: 250,
      dataSource: "surveyTypeCode",
      dataType: DATA_TYPE_STRING,
    },
    { key: "weight", name: "Weight", width: 90, dataSource: "weight" },
    {
      key: "delete",
      name: "Delete",
      width: 60,
      dataSource: deleteButton,
      dataType: DATA_TYPE_BUTTON,
      tooltip: "Click to delete",
    },
  ];

  return (
    <div className="customer-survey-type-grid-container">
      <MGrid
        headerText="Apply Costs To"
        columnDefinitions={columns}
        data={props.entries}
        onCellButtonClick={onCellButtonClick}
        actions={[{ code: ACTION_ADD, onClick: showAddDialog }]}
        disableFilters
      />
    </div>
  );
};

export default TechCostCustomerSurveyTypes;
